import styled from "styled-components";
import { ArrowDirection } from "../../common/services/realtime/stimulus-types";

export const EstimulusColorBox = styled.div<{ color?: string }>`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ color }) => color || "#fff"};
  font-size: 60px;
  font-weight: bold;
  color:#000;
`;

export const ControlSoundLabel = styled.span`
  font-size: 20px;  
  color:#000;
  font-weight: bold;
  font-family: 'Inter', Arial, sans-serif;  
  color: #000;
  margin-bottom: 10px;
`;

export const ControlSoundButtons = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  position: absolute;
  z-index: 1000;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 40%;
`;

export const SoundToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  min-height: 48px;
  padding: 8px;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #000;
  border-radius: 8px;

  &:focus-visible {
    outline: 2px solid #000;
    outline-offset: 2px;
  }
`;

export const ArrowStimulusBox = styled.div<{ $direction: ArrowDirection }>`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: ${({ $direction }) => ($direction === ArrowDirection.LEFT ? "flex-start" : "flex-end")};
  padding: 0 8vw;
  box-sizing: border-box;
  background-color: #fff;
  color: #000;
  font-size: min(50vw, 50vh);
`;

export const ControlSoundCorner = styled.div`
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 1000;
`;
